export const xlMarginY = 100

export const lgMarginY = xlMarginY - 25

export const mdMarginY = lgMarginY - 25

export const smMarginY = mdMarginY - 25

export const xsMarginY = smMarginY / 2
